import clsx from "classnames";
import { useSelector } from "react-redux";

const useMultiSelect = ({ serverError, error }) => {
    /**
     * mapStateToProps
     */
    const layoutType = useSelector((state) => state.appReducer.layoutType);
    /**
     * This is a dynamic className style pass into the react-select
     */
    const selectClass = clsx({
        "react-select-container": layoutType === "dark",
        "basic-multi-select": layoutType !== "dark"
    });
    /**
     * This is style pass into the react-select style props
     */
    const darkStyle = {
        control: (styles) => ({
            ...styles,
            backgroundColor: layoutType === "dark" ? "#282a2c !important" : "#f4f7fa !important",
            padding: "10px !important",
            border: `1px solid ${serverError || error ? "red" : "#1de9b6"}`,
            minHeight: 43,
            borderRadius: 0,
            boxShadow: "none",
            outline: "none",
            cursor: "pointer"
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: "#A389D4"
            };
        },
        multiValueLabel: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: "white",
                color: "#282a2c"
            };
        },
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: "white",
            ":hover": {
                backgroundColor: "red",
                color: "white"
            }
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "white"
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                cursor: "pointer"
            };
        }
    };

    const lightStyle = {
        control: (styles) => ({
            ...styles,
            backgroundColor: layoutType === "dark" ? "#282a2c !important" : "#f4f7fa !important",
            padding: "10px !important",
            border: `1px solid ${serverError || error ? "red" : "#1de9b6"}`,
            minHeight: 43,
            borderRadius: 0,
            boxShadow: "none",
            outline: "none",
            cursor: "pointer"
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                cursor: "pointer"
            };
        }
    };
    /**
     * This is passs into react-select style props
     */
    const customStyle = layoutType === "dark" ? darkStyle : lightStyle;
    /**
     * This is pass into react-select theme props
     * @param {object} theme
     * @returns
     */
    const customTheme = (theme) => {
        //  console.log({theme})
        return {
            ...theme,
            colors: {
                ...theme.colors,
                primary: "#1de9b6"
            }
        };
    };

    return {
        selectClass,
        customStyle,
        customTheme
    };
};

export default useMultiSelect;
